import makeStyles from "@mui/styles/makeStyles";
import { styled, Grid } from "@mui/material";

export const GridItemInfo = styled(Grid)(({ theme }) => ({
  backgroundColor: "#fafcfe",
  [theme.breakpoints.down("lg")]: {
    padding: "40px 40px 0 40px",
    width: "100%",
  },
}));

export const GridItemForm = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  padding: "47px 24px 0 24px",
  [theme.breakpoints.down("lg")]: {
    padding: "40px 40px 0 40px",
    width: "100%",
  },
}));

export const Logo = styled("img")(() => ({
  width: "180px",
}));

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "24px",
    color: "#465869",
  },
  subtitle: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "16px",
    color: "#465869",
  },
  approveImageContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "inherit",
    position: "relative",
  },
  approveImage: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
  },
}));

export default styles;
